export default __webpack_public_path__ + "9026b430f37c684953cb97432c9381c7.svg";